export default "__VITE_ASSET__CnHMYMlm__"